import localStore from './localStore'
import { ShopAPI } from 'api/shop'
import store from '@/store'; //引入store，类似组件使用this.$store
import { MyUtil } from './MyUtil';
let shopAPI = new ShopAPI()

// 购物车上的小圆点
export function getCartDot() {
  let storageCart = MyUtil.getLocalCart()
  let dot = false
  if (storageCart.product.length) {
    dot = true
  } else if (storageCart.promotion.length) {
    dot = storageCart.promotion.some(i => {
      return i.type !== 3
    })
  }
  return dot
}

// 购物车上的数字
export function getCartNum(numCallBack) {
  let storageCart = MyUtil.getLocalCart()
  let sum = 0
  storageCart.promotion.forEach(item => {
    if(item.type==5){
      item.promotionRuleVO.rules.forEach(rItem=>{
        rItem.setMealProductList.forEach(pItem=>{
          sum += (pItem.productNum*item.shopCartNum)//商品数*套数
        })
      })
    }else{
      item.promotionRuleVO.productList.forEach(pItem => {
        if (pItem.shopCartNum>0) sum += pItem.shopCartNum
      })
    }
  })
  storageCart.product.forEach(pItem => {
    if (pItem.shopCartNum>0) sum += pItem.shopCartNum
  })
  if(numCallBack) numCallBack(sum)
  return sum
}

export function setPromotion(item, isManual = 1) {
  // 对促销数据做处理，加入本地购物车
  item.promotionRuleVO.productList = item.promotionRuleVO.productList ? item.promotionRuleVO.productList : []
  item.promotionRuleVO.productList = item.promotionRuleVO.productList.map(pItem => {
    if (pItem.isHave) {
      pItem.selected = true
    }
    if (pItem.mustQty && item.type !== 4) {
      pItem.selected = true
      pItem.shopCartNum = pItem.mustQty
    }
    if (item.type === 4) {
      item.selected = true
    }
    if (item.type === 4 && (pItem.shopCartNum < pItem.mustQty || pItem.shopCartNum < pItem.mqq || (pItem.availableQty !== null && pItem.shopCartNum > pItem.availableQty))) {
      item.isNotmm = true // isNotmm不符合最低订量或者起订量
    }
    return pItem
  })
  item.ifEdit = false
  item.keyProductPrice = 0
  item.promotionTotalPrice = 0
  setCart(item, isManual)
}

//**商品、是否手工 */
export function setProduct(item, isManual = 1) {
  setCart(item, isManual)
}

export function clearLocalCart() {
  return localStore.set('TUP_cart', {
    'promotion': [],
    'product': [],
    'giftProducts': [],
    'needGiftProduct': 1
  })
}

// 整体保存，购物车页用到，type：1促销，type：2常规、3促销&常规
export function saveLocalCart(type, arr, isManual = 1) {
  //MyUtil.e(type, arr, isManual)
  let cart = MyUtil.getLocalCart()
  let promotion = type === 1 ? arr : (type === 3 ? arr.promotion : cart.promotion)
  let product = type === 2 ? arr : (type === 3 ? arr.product : cart.product)

  promotion=promotion.map(item=>{
    item.type=Number(item.type) //强转数字类型：兼容
    return item
  })

  let cartData = {
    'promotion': promotion,
    'product': product,
    'giftProducts': cart.giftProducts,
    'needGiftProduct': cart.needGiftProduct
  }
  //localStore.set('TUP_cart', cartData)
  sendLineCart(isManual, cartData, () => {
    //console.log("--------更新远程购物车成功----------type:", type)
    localStore.set('TUP_cart', cartData)
    //触发更新购物车数目
    store.state.cartFlag += 1
  }, () => {
    //console.log("--------更新远程购物车失败，本地还原----------type:", type)
    //localStore.set('TUP_cart', cart)
  })
}

/**保存购物车 */
function sendLineCart(isManual,cartData,successAction,failAction) {
  let data = {}
  data.products = cartData.product
  data.promotions = cartData.promotion

  data.giftProducts = cartData.giftProducts
  data.needGiftProduct = cartData.needGiftProduct
  data.isManualAddCart = isManual // 是否手动加购物车 1是 0否，0是在登录时加入满单以及指定赠送时会用到
  if (!isManual && !data.promotions && !data.products) {
    return
  }
  shopAPI.refreshCart(data).then(res => {
    if(res.success && successAction){
      successAction()   
    }else if (failAction) {
      failAction()
    }
  },() => {
    if (failAction) failAction()
  })
}

function setCart(item, isManual = 1) { // 订货页用到
  let cart = MyUtil.getLocalCart()
  if (item) {
    let isPromotion = typeof item.promotionRuleVO !== 'undefined'
    let arr = isPromotion ? cart.promotion : cart.product
    arr = unique(arr, item)
    saveLocalCart(isPromotion ? 1 : 2, arr, isManual)
  }
}

function unique(arr, item) {
  if (arr.length && item.type!==5) {
    for (let i = 0, len = arr.length; i < len; i++) {
      if (typeof item.promotionRuleVO === 'undefined' && arr[i].pCode === item.pCode) { // pCode判断常规产品
        if (item.shopCartNum === 0) {
          arr.splice(i, 1)
        } else {
          arr[i].shopCartNum = item.shopCartNum
        }
        return arr

      }else if (typeof item.promotionRuleVO !== 'undefined' && arr[i].id === item.id) { // id判断促销
        if (item.shopCartNum === 0) {
          arr.splice(i, 1)
        } else {
          arr[i].promotionRuleVO = item.promotionRuleVO
        }
        return arr

      } else if (i === len - 1) {
        if (item.type === 3) { // 满单在后面添加
          arr.push(item)
        } else {
          arr.unshift(item)
        }
      }
    }
  } else {
    arr.unshift(item)
  }
  return arr
}



// WEBPACK FOOTER //
// ./src/util/cart.js